import { useEffect, useState } from 'react';
import { getInitialDensity, applyDensity, type Density } from '../lib/density';

export function useDensity(): [Density, (d: Density) => void] {
  const [density, setDensity] = useState<Density>(() => getInitialDensity());
  useEffect(() => applyDensity(density), [density]);
  return [density, setDensity];
}
